<template>
  <div class="show" v-if="showInfo">
    <div class="header">
      <div class="headerbox">
          <img :src="`${IP_TEST}/uploads/${logopic}`" alt="" @click="$router.push('/')">
          <div class="back">
              <a class="light" href="/inquery?inqtype=ry">继续查询</a>
            <a href="/">返回页面</a>
        </div>
      
      </div>
    
    </div>
    <div class="box">
      <div class="content">
        <!-- <div class="headerinfo">
          <h2>
            企业荣誉查询结果
          </h2>
          <a class="back" href="/inquery"><img src="/static/img/chaxunicon.png" alt="">
            继续查询</a>
        </div> -->
        <div class="detailInfo" style="padding-top:0;">
           <h2>
              企业荣誉查询结果
            </h2>
            <div class="theader">企业基本信息</div>
          <table width="1143px" align="center">
            <!-- <tr>
              <td colspan="4" class="ttitle"><img src="/static/img/zuo.png" alt=""> 企业基本信息<img src="/static/img/you.png" alt=""></td>
            </tr> -->
            <tr>
              <td>单位名称：</td>
              <td colspan="3">{{ showInfo.qiyename }}</td>
            </tr>
            <tr>
              <td>法定代表人：</td>
              <td colspan="3">{{ showInfo.legalperson }}</td>
            </tr>
            <tr>
              <td>企业类型：</td>
              <td colspan="3">{{ showInfo.qiyetype }}</td>
            </tr>
            <tr>
              <td>企业信用代码：</td>
              <td colspan="3">{{ showInfo.socialcreditcode }}</td>
            </tr>
            <tr>
              <td>注册地址：</td>
              <td colspan="3">{{ showInfo.address}}</td>
            </tr>
          </table>
        </div>
        <div class="detailInfo">
           <div class="theader">荣誉基本信息</div>
          <table width="1143px" align="center">
            <!-- <tr>
              <td colspan="5" class="ttitle"><img src="/static/img/zuo.png" alt=""> 荣誉基本信息<img src="/static/img/you.png" alt=""></td>
            </tr> -->
            <tr>
              <td>荣誉名称：</td>
              <td colspan="4">{{ showInfo.certname }}</td>
            </tr>
            <tr>
              <td>荣誉类型：</td>
              <td colspan="4">{{ showInfo.certtype }}</td>
            </tr>
            <tr>
              <td>荣誉等级：</td>
              <td colspan="4">{{ showInfo.certlevel }}</td>
            </tr>
            <tr>
              <td>签发编号：</td>
              <td colspan="4">{{ showInfo.code }}</td>
            </tr>
            <tr>
              <td>签发时间：</td>
              <td colspan="4">{{ showInfo.certdate }}</td>
            </tr>
            <tr>
              <td>签发单位：</td>
              <td colspan="4">{{ showInfo.regauth}}</td>
            </tr>
            <tr>
              <td>查询网址：</td>
              <td colspan="4">{{ showInfo.regurl}}</td>
            </tr>
            <tr>
              <td>年检记录：</td>
              <td style="width:100px;text-align: center;height: 120px;" >

                <img v-if="arrSprtQys[0]" :src="`/static/img/yinians.jpg`" width="142"/><br/>
                {{arrSprtQys[0]&&arrSprtQys[0].date}}
              </td>
              <td style="width:100px;text-align: center;">
                <img v-if="arrSprtQys[1]" :src="`/static/img/yinians.jpg`" width="142"/><br/>
                {{arrSprtQys[1]&&arrSprtQys[1].date}}
              </td>
              <td style="width:100px;text-align: center;">
                <img v-if="arrSprtQys[2]" :src="`/static/img/yinians.jpg`" width="142"/><br/>
                {{arrSprtQys[2]&&arrSprtQys[2].date}}
              </td>
              <td style="width:100px;text-align: center;">
                <img v-if="arrSprtQys[3]" :src="`/static/img/yinians.jpg`" width="142"/><br/>
                {{arrSprtQys[3]&&arrSprtQys[3].date}}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="bacc">版权所有：zhcp.org.cn</div>
  </div>
</template>

<script>
/**
 * 企业证书查询系统模版
 */
import { IP_TEST } from '@/config';
const rate = window.outerWidth / 1400
export default {
  metaInfo: {
    title: '培训信息查询结果',
    meta: [
      {
        name: 'viewport', content:
          `width=device-width, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`
      }
    ]
  },
  name: "ShowQy",
  data() {
    return {
      IP_TEST,
      arrSprtQys:[]
    }
  },
  computed:{
    logopic() {
      return this.$store.getters.logopic;
    }
  },
  props: {
    showInfo: Object
  },
  mounted() {
    if(this.showInfo.nianjian)
    {
      let arrtmpsprts=this.showInfo.nianjian.split("##");
     
      for(let i = 0; i < arrtmpsprts.length;i++) {
        this.arrSprtQys[i]={
          title:arrtmpsprts[i].split("||")[0],
          date:arrtmpsprts[i].split("||")[1],
        }
      }
      this.$forceUpdate();
    }
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    formatExcelData(value) {
      let dataStr = this.formatExcel(value);
      if (isNaN(dataStr) && !isNaN(Date.parse(dataStr))) {
          value = new Date(dataStr);
          if (dataStr.indexOf("/") == -1 && dataStr.indexOf("-") == -1)
              value.setDate(value.getDate() + 1);
          value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
          -2
          )}月${("00" + value.getDate()).slice(-2)}日`;
          return value;
      } else {
          if (dataStr.indexOf("年") > -1) {
              var ttDate = dataStr.match(/\d{4}.\d{1,2}.\d{1,2}/gm).toString();
              ttDate = ttDate.replace(/[^0-9]/gm, "-");
              value = new Date(ttDate);
              value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
              return value;
          } else {
              if (!isNaN(dataStr)) {
                  var data = new Date(1900, 0, dataStr);
                  value = data;
                  value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
                  return value;
              } else {
                  return dataStr;
              }
          }
      }
    },
    formatExcel(value) {
        if (!value) {
            return "";
        } else {
            if (typeof value == "string") {
                return value.trim();
            } else {
                return value.toString().trim();
            }
        }
    }
  }
};
</script>
<style scoped>
.tip{
  position: relative;
  margin:auto;
  width: 950px;
  padding-left: 193px;
height: 61px;
background: #FFEEED;
font-size: 18px;
font-family: PingFang SC;
font-weight: bold;
color: #F24040;
line-height:61px;
background-image: url(/static/img/img/reccet.png);
background-repeat: no-repeat;
background-size: 20px 20px;
background-position: 163px center;
}
.show{
  position: relative;
  width: 100%;
  min-height: 1130px;
  background-color: #EEF0F5;
}
.show .box{
  width: 1300px;
  margin: auto;
  position: relative;
  /* top:47px; */
}
/* header */
.header{
  width: 100%;
  padding:16px 0 16px;

height: auto;
background: #FFFFFF;
box-shadow: 0px 2px 10px 0px rgba(65,65,65,0.09);
}
.headerbox{
  width: 1300px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.headerbox img{
  width:608px;
  /* height:49px; */
}
.headerbox .back{
  float:right;
  width: 258px;
  height: 42px;
border: 1px solid #2F8EEC;
}
.headerbox a{
  display: inline-block;
  width: 129px;
height: 42px;
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #666666;
line-height: 42px;

text-align: center;
}
.headerbox a.light{
background: #2E8EEB;
color: #FFFFFF;
}
/* header */
.content .detailInfo{
  height: 580px;
  margin-top:19px;
  background: #FFFFFF;
}
.content .detailInfo h2{
  /* background-image: url(/static/img/baiotiti.png); */
    /* background-repeat: no-repeat; */
    /* background-size: contain; */
    height: 35px;
    margin: auto;
    position: relative;
    padding: 69px 0 85px;
    font-size: 35px;
    text-align: center;
    line-height: 35px;
    font-weight: bold;
    color: #333333;
}
.content .detailInfo h2::after{
  position: absolute;
  content:'';
  left:631px;
  bottom:48px;
  width: 37px;
height: 8px;
background: #2E8EEB;
border-radius: 3px;
}
.compytitle{
  height: 171px;
  width:1143px;
  margin: auto;
  position: relative;
  /* left: 41px; */
  border-radius: 5px;
}
.compytitle img{
  width: 125px;
}
.compytitle .info{
  padding-top: 10px;
  padding-left:20px;
  width:960px;
  display: inline-block;
}
.compytitle h3{
    font-size: 16px;
  /* font-weight: bold; */
  color: #999999;
  /* letter-spacing: 4px; */
}
.compytitle p{
  color: #999999;
    font-size: 16px;
    font-weight: 400;
    /* letter-spacing: 3px; */
    margin-top: 13px;
    line-height: 33px;
}
.codeinfo{
  margin-top: 18px;
  width: 1300px;
  height: 65px;
  background: #FFFFFF;
  line-height: 65px;
  font-size: 16px;
  color: #999999;
}
.codeinfo img{
  margin-left: 78px;
  margin-right: 12px;
  position: relative;

    top: 19px;
}
.detailInfo{
  padding: 20px 0;
  margin-top:18px;
  width: 1300px;
  min-height: 255px;
  background: #FFFFFF;
  overflow: hidden;
}

.detailInfo td{
  border:1px solid #7B93D0;
  /* padding:5px 15px; */
  min-height: 54px;
  height: 54px;
  padding-left: 32px;
  font-size: 21px;
  line-height: 33px;
}
.detailInfo tr td:nth-child(2n-1){
  font-size: 16px;
color: #999999;
  width: 163px;
}
.detailInfo tr td:nth-child(2n){
  width: 469px;
  font-size: 16px;
  color: #333333;
}
.perinfo .back{
  color: #2E8EEB;
    position: absolute;
    right: 78px;
    font-size: 16px;
    border-bottom: solid 1px;
    line-height: 25px;
}
.perinfo{
  position: relative;
  margin-top: 60px;
  margin-bottom: 42px;
  width: 1216px;
  padding-left: 84px;
height: 24px;
font-size: 24px;
font-family: PingFang SC;
font-weight: bold;
color: #333333;
line-height: 24px;
}
.bacc{
  position: relative;
  margin-top:61px;
  text-align: center;
height: 14px;
font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #000000;
line-height: 14px;
}
.theader{
  position: relative;
  margin:0 auto 0;
  width: 1143px;
  height: 24px;
  text-align: left;
  font-weight: bold;
  color: #000000;
  font-size: 24px;
  line-height: 24px;
  padding-bottom:22px ;
}
</style>